import React from 'react';
import styles from './GameRulesContent.module.scss';
import gameStyles from './GameDetails.module.scss';
import { GameTileProps } from '../modular-grid/types';

interface GameRulesPropsType {
  game: GameTileProps;
}

const GameRulesContent: React.FC<GameRulesPropsType> = ({ game }) => {
  return (
    <div className={styles.wrapper}>
      <div
        data-testid="game-rules-description"
        className={gameStyles.styles}
        dangerouslySetInnerHTML={{
          __html: game.rules || '',
        }}
      ></div>
    </div>
  );
};

export default GameRulesContent;
